export default __webpack_public_path__ + "images/b79bb2fceb07732fd9cb9ebc9829f226.png";